import React from 'react';
import BaseModal from '../../../../Base/Components/BaseModal/BaseModal';
import DENTDentalCrossStartMedicalExaminationForm from './DENTDentalCrossStartMedicalExaminationForm';

interface Props {
	onClose: () => void;
}

const DENTDentalCrossStartMedicalExamination = ({ onClose }: Props) => {
	return (
		<BaseModal
			title={
				'patientTreatment.meddiDENT.dentalCross.actions.dentitionVisit.start'
			}
			isOpen
			onClose={onClose}>
			<DENTDentalCrossStartMedicalExaminationForm onSuccess={onClose} />
		</BaseModal>
	);
};

export default DENTDentalCrossStartMedicalExamination;
